const MATCH_ONLY_100 = 'MatchOnly100';
const COVERAGE_100 = 'Coverage100';
const COVERAGE_75 = 'Coverage75';
const COVERAGE_50 = 'Coverage50';
const COVERAGE_25 = 'Coverage25';

export const TimePeriodRatioOption = Object.freeze({
    [MATCH_ONLY_100]: 0,
    [COVERAGE_100]: 1,
    [COVERAGE_75]: 2,
    [COVERAGE_50]: 3,
    [COVERAGE_25]: 4,
});

export const TimePeriodRatioOptionNames = Object.freeze({
    0: MATCH_ONLY_100,
    1: COVERAGE_100,
    2: COVERAGE_75,
    3: COVERAGE_50,
    4: COVERAGE_25,
});
